export default "__VITE_ASSET__D3Rkb9E1__"